import './PacsearchTable.scss';
import {
  FixedHeader
} from 'src/components/table/FixedHeader.ts';

export class PacsearchTable {
  constructor(){
    let containers = document.querySelectorAll('.pacsearch-table')
    for(let i=0;i<containers.length; i++){
      let container = containers[i] as HTMLElement;
      let table = container.querySelector('table');
      new FixedHeader(container, table)
    }
  }
}
